import { gql } from 'graphql-request'

export const GET_BANNER_DETAIL = gql`
  query GetHighlightBookBanner($getHighlightBookBannerId: Int!) {
    getHighlightBookBanner(id: $getHighlightBookBannerId) {
      bannerName
    }
  }
`
